import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "rv-top" }
const _hoisted_2 = { class: "rv-count" }
const _hoisted_3 = {
  key: 0,
  class: "ep-seg rv-tog",
  role: "tablist",
  "aria-label": "How to show the seats"
}
const _hoisted_4 = ["aria-selected", "onClick"]
const _hoisted_5 = { viewBox: "0 0 24 24" }
const _hoisted_6 = ["d"]
const _hoisted_7 = {
  key: 0,
  class: "rv-empty"
}
const _hoisted_8 = {
  key: 0,
  class: "rv-seats",
  role: "tablist",
  "aria-label": "Seats"
}
const _hoisted_9 = ["aria-selected", "onClick"]
const _hoisted_10 = { class: "rs-seat-i" }
const _hoisted_11 = { class: "rv-seat-t" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "rv-page" }
const _hoisted_14 = { class: "rv-seathead" }
const _hoisted_15 = { class: "rv-big" }
const _hoisted_16 = { class: "rv-seathead-t" }
const _hoisted_17 = { class: "rv-sn" }
const _hoisted_18 = {
  key: 0,
  class: "rv-st"
}
const _hoisted_19 = {
  key: 1,
  class: "rv-chips"
}
const _hoisted_20 = { class: "rv-chip" }
const _hoisted_21 = {
  key: 0,
  class: "rv-nav"
}
const _hoisted_22 = {
  key: 0,
  class: "rv-actions"
}
const _hoisted_23 = {
  key: 1,
  class: "rv-toc",
  role: "navigation",
  "aria-label": "Sections"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 2,
  class: "rv-empty"
}
const _hoisted_26 = {
  key: 3,
  class: "rv-missing"
}
const _hoisted_27 = {
  class: "rv-toc rv-alljump",
  role: "navigation",
  "aria-label": "Seats"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "rs-seat-i" }
const _hoisted_30 = ["id"]
const _hoisted_31 = { class: "rv-seathead" }
const _hoisted_32 = { class: "rv-big" }
const _hoisted_33 = { class: "rv-seathead-t" }
const _hoisted_34 = { class: "rv-sn" }
const _hoisted_35 = {
  key: 0,
  class: "rv-st"
}
const _hoisted_36 = { class: "rv-nav" }
const _hoisted_37 = {
  key: 0,
  class: "rv-empty"
}
const _hoisted_38 = { class: "rv-cmp-bar" }
const _hoisted_39 = {
  class: "rv-zoom",
  role: "group",
  "aria-label": "Text size"
}
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "rv-cmp-wrap" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "rs-seat-i" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "rv-band" }
const _hoisted_47 = ["colspan"]
const _hoisted_48 = {
  key: 0,
  class: "rv-rich rv-accl"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "rv-band" }
const _hoisted_52 = ["colspan"]
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_role_seat = _resolveComponent("role-seat")!

  return (_openBlock(), _createElementBlock("div", {
    class: "rv",
    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onContentClick && _ctx.onContentClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.seats.length) + " seat" + _toDisplayString(_ctx.seats.length == 1 ? '' : 's') + " · " + _toDisplayString(_ctx.sections.length) + " section" + _toDisplayString(_ctx.sections.length == 1 ? '' : 's') + " each", 1),
      (_ctx.seats.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (m) => {
              return (_openBlock(), _createElementBlock("button", {
                key: m.id,
                type: "button",
                role: "tab",
                "aria-selected": _ctx.mode == m.id,
                class: _normalizeClass({ on: _ctx.mode == m.id }),
                onClick: ($event: any) => (_ctx.mode = m.id)
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                  _createElementVNode("path", {
                    d: m.icon
                  }, null, 8, _hoisted_6)
                ])),
                _createTextVNode(_toDisplayString(m.label), 1)
              ], 10, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.seats.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "No seats on this role sheet yet."))
      : (_ctx.mode == 'seat')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.seats.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat, i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: seat.id,
                      type: "button",
                      role: "tab",
                      "aria-selected": _ctx.selected == i,
                      class: _normalizeClass(['rv-seat', { on: _ctx.selected == i }]),
                      onClick: ($event: any) => (_ctx.selected = i)
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.initials(seat)), 1),
                      _createElementVNode("span", _hoisted_11, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.heading(seat).main || 'Seat ' + (i + 1)), 1),
                        (_ctx.heading(seat).sub)
                          ? (_openBlock(), _createElementBlock("em", _hoisted_12, _toDisplayString(_ctx.heading(seat).sub), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_9))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("header", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.initials(_ctx.current)), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.heading(_ctx.current).main || 'Seat ' + (_ctx.selected + 1)), 1),
                  (_ctx.heading(_ctx.current).sub)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.heading(_ctx.current).sub), 1))
                    : _createCommentVNode("", true),
                  (_ctx.reportsTo(_ctx.current))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, [
                          _cache[10] || (_cache[10] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                            _createElementVNode("path", { d: "M12 19V5M6 11l6-6 6 6" })
                          ], -1)),
                          _createTextVNode("Reports to " + _toDisplayString(_ctx.reportsTo(_ctx.current)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.seats.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "Previous seat",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selected = (_ctx.selected - 1 + _ctx.seats.length) % _ctx.seats.length))
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", { d: "M15 18l-6-6 6-6" })
                        ], -1)
                      ]))]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.selected + 1) + " of " + _toDisplayString(_ctx.seats.length), 1),
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "Next seat",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = (_ctx.selected + 1) % _ctx.seats.length))
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", { d: "M9 6l6 6-6 6" })
                        ], -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.actions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn rv-act",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('sign', _ctx.current)))
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M3 17c3.33-3.33 5-6 5-8a3 3 0 0 0-6 0c0 3 3 4.5 4.5 6.5C7.5 16.8 8.3 18 9 18c1.5 0 2.5-3 3-3s1 2 2.5 2c.6 0 1.6-.6 2.5-2M17 20h4" })
                      ], -1),
                      _createTextVNode("Sign off", -1)
                    ]))]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ep-chip",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('share', _ctx.current)))
                    }, [...(_cache[14] || (_cache[14] = [
                      _createStaticVNode("<svg viewBox=\"0 0 24 24\"><circle cx=\"6\" cy=\"12\" r=\"3\"></circle><circle cx=\"18\" cy=\"6\" r=\"3\"></circle><circle cx=\"18\" cy=\"18\" r=\"3\"></circle><path d=\"M8.7 10.7l6.6-3.4M8.7 13.3l6.6 3.4\"></path></svg>Share", 2)
                    ]))]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ep-chip",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copySeat(_ctx.current)))
                    }, [
                      _cache[15] || (_cache[15] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M9 9h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V9zM5 15H4a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v1" })
                      ], -1)),
                      _createTextVNode(_toDisplayString(_ctx.copied == 'text' ? 'Copied' : 'Copy'), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ep-chip",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyLink(_ctx.current)))
                    }, [
                      _cache[16] || (_cache[16] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M9 15l6-6M11 6l.46-.54a5 5 0 0 1 7.07 7.07L18 13M13 18l-.4.53a5.07 5.07 0 0 1-7.12 0 4.97 4.97 0 0 1 0-7.07L6 11" })
                      ], -1)),
                      _createTextVNode(_toDisplayString(_ctx.copied == 'link' ? 'Link copied' : 'Copy link'), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.filled(_ctx.current).length > 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_ctx.accs(_ctx.current).length)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.jump('acc')), ["prevent"]))
                        }, "Accountabilities"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filled(_ctx.current), (section) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: section.id,
                        onClick: _withModifiers(($event: any) => (_ctx.jump(section.id)), ["prevent"])
                      }, _toDisplayString(section.label.replace(/\s*\(\d+\)\s*$/, '')), 9, _hoisted_24))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_role_seat, {
                accountabilities: _ctx.current.accountabilities,
                sections: _ctx.sectionsOf(_ctx.current),
                prefix: 'rv-' + _ctx.current.id
              }, null, 8, ["accountabilities", "sections", "prefix"]),
              (!_ctx.accs(_ctx.current).length && !_ctx.filled(_ctx.current).length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_25, "This seat hasn't been filled in yet."))
                : _createCommentVNode("", true),
              (_ctx.isAdmin && _ctx.missing(_ctx.current))
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                    _cache[17] || (_cache[17] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "9"
                      }),
                      _createElementVNode("path", { d: "M12 8h.01M11 12h1v4h1" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.missing(_ctx.current)) + " section" + _toDisplayString(_ctx.missing(_ctx.current) == 1 ? " isn't" : "s aren't") + " filled in for this seat, so " + _toDisplayString(_ctx.missing(_ctx.current) == 1 ? "it's" : "they're") + " hidden. Edit the role sheet to add " + _toDisplayString(_ctx.missing(_ctx.current) == 1 ? 'it' : 'them') + ". ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : (_ctx.mode == 'all')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat, i) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: seat.id,
                    onClick: _withModifiers(($event: any) => (_ctx.jumpSeat(i)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.initials(seat)), 1),
                    _createTextVNode(_toDisplayString(_ctx.heading(seat).main || 'Seat ' + (i + 1)), 1)
                  ], 8, _hoisted_28))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: seat.id,
                  id: 'rv-seat-' + i,
                  class: "rv-page rv-allpage"
                }, [
                  _createElementVNode("header", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.initials(seat)), 1),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.heading(seat).main || 'Seat ' + (i + 1)), 1),
                      (_ctx.heading(seat).sub)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.heading(seat).sub), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("span", null, "Seat " + _toDisplayString(i + 1) + " of " + _toDisplayString(_ctx.seats.length), 1)
                    ])
                  ]),
                  _createVNode(_component_role_seat, {
                    accountabilities: seat.accountabilities,
                    sections: _ctx.sectionsOf(seat),
                    prefix: 'rv-all-' + seat.id
                  }, null, 8, ["accountabilities", "sections", "prefix"]),
                  (!_ctx.accs(seat).length && !_ctx.filled(seat).length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, "This seat hasn't been filled in yet."))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_30))
              }), 128))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_38, [
                _cache[20] || (_cache[20] = _createElementVNode("span", null, "Scroll sideways to see every seat. Click a seat name to read it on its own.", -1)),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Smaller text",
                    disabled: _ctx.zoom <= 0.8,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setZoom(-0.1)))
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                      _createElementVNode("path", { d: "M5 12h14" })
                    ], -1)
                  ]))], 8, _hoisted_40),
                  _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.zoom * 100)) + "%", 1),
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Larger text",
                    disabled: _ctx.zoom >= 1.3,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setZoom(0.1)))
                  }, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                      _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                    ], -1)
                  ]))], 8, _hoisted_41)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("table", {
                  class: "rv-cmp",
                  style: _normalizeStyle({ fontSize: (13.5 * _ctx.zoom).toFixed(1) + 'px', width: _ctx.seats.length * _ctx.colWidth + 'px' })
                }, [
                  _createElementVNode("colgroup", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat) => {
                      return (_openBlock(), _createElementBlock("col", {
                        key: seat.id,
                        style: _normalizeStyle({ width: _ctx.colWidth + 'px' })
                      }, null, 4))
                    }), 128))
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat, i) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: seat.id,
                          class: "rv-cmp-seat"
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            title: "Open this seat on its own",
                            onClick: ($event: any) => (_ctx.openSeat(i))
                          }, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.initials(seat)), 1),
                            _createElementVNode("span", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.heading(seat).main || 'Seat ' + (i + 1)), 1),
                              (_ctx.heading(seat).sub)
                                ? (_openBlock(), _createElementBlock("em", _hoisted_45, _toDisplayString(_ctx.heading(seat).sub), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_43)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.seats.some(s => _ctx.accs(s).length))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("tr", _hoisted_46, [
                            _createElementVNode("th", {
                              colspan: _ctx.seats.length
                            }, [...(_cache[21] || (_cache[21] = [
                              _createElementVNode("span", null, "Accountabilities", -1)
                            ]))], 8, _hoisted_47)
                          ]),
                          _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: seat.id,
                                class: _normalizeClass(['rv-cmp-cell', { empty: !_ctx.accs(seat).length }])
                              }, [
                                (_ctx.accs(seat).length)
                                  ? (_openBlock(), _createElementBlock("ol", _hoisted_48, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accs(seat), (a, k) => {
                                        return (_openBlock(), _createElementBlock("li", { key: k }, [
                                          _createElementVNode("b", null, _toDisplayString(a.value), 1),
                                          (a.value2)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_49, " — " + _toDisplayString(a.value2), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_50, "Not filled in"))
                              ], 2))
                            }), 128))
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.id
                      }, [
                        _createElementVNode("tr", _hoisted_51, [
                          _createElementVNode("th", {
                            colspan: _ctx.seats.length
                          }, [
                            _createElementVNode("span", null, _toDisplayString(section.label), 1)
                          ], 8, _hoisted_52)
                        ]),
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: seat.id,
                              class: _normalizeClass(['rv-cmp-cell', { empty: !_ctx.hasText(seat.values[section.id]) }])
                            }, [
                              (_ctx.hasText(seat.values[section.id]))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "rv-rich ve-body",
                                    innerHTML: seat.values[section.id]
                                  }, null, 8, _hoisted_53))
                                : (_openBlock(), _createElementBlock("span", _hoisted_54, "Not filled in"))
                            ], 2))
                          }), 128))
                        ])
                      ], 64))
                    }), 128))
                  ])
                ], 4)
              ])
            ], 64))
  ]))
}